<template>
  <el-card shadow="always">
    <div slot="header" class="clearfix">
      <span>Destinatário</span>
    </div>
    <div>
      <el-form
        ref="form"
        :model="ruleForm"
        label-width="120px"
        :label-position="labelPosition"
      >
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item class="no-margin-bottom" :label="$t('destinatario')" prop="delivery">
              <DeliveryList
                ref="deliveryList"
                v-model="ruleForm.delivery"
                :customer="customer"
                v-on:clear="clear"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="18" :xl="18">
            <el-form-item
              :label="$t('nome')"
              prop="name"
              maxlength="50"
              class="no-margin-bottom"
              :required="true"
            >
              <el-input v-model="ruleForm.name" maxlength="40"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item class="no-margin-bottom" label="Telefone" :required="true">
              <el-input v-mask="['(##) ####-####', '(##) #####-####']" v-model="ruleForm.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="18" :sm="18" :md="18" :lg="12" :xl="12">
            <el-form-item
              class="no-margin-bottom"
              :label="$t('cep')"
              prop="cep"
              :required="true"
            >
              <el-input
                maxlength="9"
                v-model="ruleForm.cep"
                v-mask="'#####-###'"
                v-loading="loading"
                @blur="zipcode()"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item
              :label="$t('endereco')"
              prop="address"
              class="no-margin-bottom"
              :required="true"
            >
              <el-input v-model="ruleForm.address" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="10">
            <el-form-item
              :label="$t('bairro')"
              prop="neighborhood"
              class="no-margin-bottom"
              :required="true"
            >
              <el-input v-model="ruleForm.neighborhood" maxlength="35"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
            <el-form-item
              class="no-margin-bottom"
              :label="$t('cidade')"
              prop="city"
              :required="true"
            >
              <el-input v-model="ruleForm.city" maxlength="35"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="6">
            <el-form-item
              class="no-margin-bottom"
              :label="$t('estado')"
              prop="state"
              :required="true"
            >
              <el-input maxlength="2" v-model="ruleForm.state"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="10" :xl="6">
            <el-form-item
              class="no-margin-bottom"
              label="Número"
              maxlength="5"
              :required="true"
            >
              <el-input maxlength="5" v-model="ruleForm.number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="18">
            <el-form-item class="no-margin-bottom" label="Complemento">
              <el-input maxlength="30" v-model="ruleForm.extent"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-card>
</template>
<script>
//import { UserService } from "@/services/users/user.services";
import { i18n } from "@/plugin/i18n";
import { DeliveryService } from "@/services/delivery/delivery.services";
import { PostOfficeService } from "@/services/post.office/post.office.services";
import { UserService } from "@/services/users/user.services";
import FederalId from "@/xpost/components/FederalId";
import DeliveryList from "@/xpost/views/register/delivery/DeliveryList";
import DepartmentList from "@/xpost/views/register/department/DepartmentList";

export default {
  name: "MotoboyDeliver",
  components: {
    FederalId,
    DeliveryList,
    DepartmentList,
  },
  props: ["customer", "state", "labelPosition", "userType"],
  watch: {
    "ruleForm.delivery": function (newVal, oldVal) {
      const vm = this;
      vm.fetchDelivery();
    },
  },
  methods: {
    validate() {
      const vm = this;
      return (
        vm.ruleForm.cep &&
        vm.ruleForm.address &&
        vm.ruleForm.neighborhood &&
        vm.ruleForm.city &&
        vm.ruleForm.state &&
        vm.ruleForm.number &&
        vm.ruleForm.name
      );
    },
    zipcode: function () {
      const vm = this;
      if (!vm.ruleForm.cep) {
        return false;
      }
      const loading = vm.$loading(vm.$options.loading);
      PostOfficeService.zipcode(vm.ruleForm.cep)
        .then((response) => {
          vm.ruleForm.address = response.end;
          vm.ruleForm.city = response.cidade;
          vm.ruleForm.state = response.uf;
          vm.ruleForm.neighborhood = response.bairro;
        })
        .catch(() => {
          vm.$message({
            type: "error",
            message: i18n.tc("cep-invalido"),
            duration: 5000,
          });
        })
        .finally(() => loading.close());
    },
    confirm() {
      const vm = this;
      vm.$emit("add");
    },
    fetchDelivery() {
      const vm = this;
      if (!vm.ruleForm.delivery) return false;
      vm.loading = true;
      DeliveryService.get(vm.ruleForm.delivery)
        .then((response) => {
          vm.ruleForm.cep = response.zipcode.zipcode;
          vm.ruleForm.address = response.address || response.zipcode.address;
          vm.ruleForm.name = response.name;
          vm.ruleForm.neighborhood = response.neighborhood || response.zipcode.neighborhood;
          vm.ruleForm.city = response.zipcode.city;
          vm.ruleForm.state = response.zipcode.state;
          vm.ruleForm.number = response.number;
          vm.ruleForm.extent = response.extent;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => (vm.loading = false));
    },
    clear() {
      const vm = this;
      vm.ruleForm.delivery = "";
      vm.ruleForm.department = "";
      vm.ruleForm.cep = "";
      vm.ruleForm.contact = "";
      vm.ruleForm.address = "";
      vm.ruleForm.neighborhood = "";
      vm.ruleForm.city = "";
      vm.ruleForm.state = "";
      vm.ruleForm.number = "";
      vm.ruleForm.extent = "";
      vm.ruleForm.name = "";
      vm.ruleForm.phone = "";
    },
  },
  data() {
    return {
      loading: false,
      ruleForm: {
        delivery: "",
        department: "",
        cep: "",
        address: "",
        phone: "",
        neighborhood: "",
        city: "",
        state: "",
        number: "",
        extent: "",
        name: "",
      },
    };
  },
};
</script>
